// extracted by mini-css-extract-plugin
module.exports = {"textInfo":"FormBuilder_textInfo__2-ByB"};